export const SET_BLUEPRINT = 'SignUpSheet/*/SET_BLUEPRINT';
export const BLUEPRINT_TYPE_ITEMS = 'items';
export const BLUEPRINT_TYPE_DATE = 'date-slots';
export const BLUEPRINT_TYPE_DATETIME = 'datetime-slots';
export const BLUEPRINT_TYPE_DATETIME_WITH_QUANTITY = 'datetime-slots-with-quantity';
